import { dataProps } from './properties'

export const setCampaignList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setCampaignOutstandingList = (state, payload) => {
    state.outstanding_list = payload
}

export const resetCampaignOutstandingList = state => {
    state.outstanding_list = []
}

export const setCampaignData = (state, payload) => {
    state.props = payload.response
}

export const setPurchaseOrderShippingAddress = (state, payload) => {
    state.props.shipment_address 
        = payload.legal_name+'\r\n'+payload.address+',\r\n'+payload.city_name+'-'+payload.postal_code+', '
                +payload.province_name+', '+payload.country_name+'.\r\n'
                +payload.contact_number+', '+payload.email_address+'.'
}

/*export const addNewCampaignItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}*/

export const removeCampaignItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setCampaignCustomerList = (state, payload) => {
    
    let list = payload.filter((thing, index, self) =>
    index === self.findIndex((t) => (t.customer_id === thing.customer_id && t.customer_id>0))
)       
    payload.filter(t => t.customer_id === 0).forEach(element => {
        list.push(element)
    })

    state.props.customer_list = list
}

export const resetCampaignData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/campaign/mutations.js